import { Injectable, OnDestroy } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { SearchedInfo } from '../models/search-info';
import { Observable, of, Subject } from 'rxjs';
import { DnvLatLng, DnvMapInfo, SearchItem, SearchItemType } from 'dnv-lib';

import { ApplicationState, LocationCoordinate, PopulationState, SearchCoordinatesPayload, SearchLocation, ToolboxMailMergeState, ToolboxStatus } from '../state-management/application/application.state';
// import { environment } from 'src/environments/environment';
import { createFeatureSelector, Store } from '@ngrx/store';
import { takeUntil } from 'rxjs/operators';

export interface AppliState {
    applicationReducer: ApplicationState;
}

export const getAppliState = createFeatureSelector<ApplicationState>('applicationReducer');

@Injectable()
export class PropertiesService implements OnDestroy {
    private ngUnsubscribe: Subject<void> = new Subject();
    appSettings: any;
    toolboxMailMergeState: ToolboxMailMergeState;
    populationState: PopulationState;
    toolboxStatus: ToolboxStatus;
    gisUrl = 'api/gis/';
    propertiesUrl = 'api/properties/';
    httpOptions = {
        headers: new HttpHeaders({
            'Cache-Control': 'no-cache',
            Pragma: 'no-cache'
        })

    };
    httpOptionsString = {
        headers: new HttpHeaders({
            'Cache-Control': 'no-cache',
            Pragma: 'no-cache'
        }),
        responseType: 'text' as const
    };

    constructor(
        private httpClient: HttpClient,
        private store: Store<AppliState>
    ) {
        this.store.select(getAppliState).pipe(
            takeUntil(this.ngUnsubscribe)
        ).subscribe((state: any) => {
            this.appSettings = state.appSettings;
            this.toolboxMailMergeState = state.toolboxMailMergeState;
            this.populationState = state.populationState;
            this.toolboxStatus = state.toolboxStatus;
        });
    }

    ngOnDestroy(): void {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }

    getPropertyByXY(latlng: DnvLatLng): any {

        const url = this.appSettings['environment.folioSearchApiEndpointUrl'];
        const query = this.appSettings['searchService.commonQuerylayers'] + '/query?f=json&where=&returnGeometry=true&spatialRel=esriSpatialRelIntersects&geometry=%7B%20%22x%22:' + latlng.lng + ',%20%22y%22:' + latlng.lat + ',%20%22spatialReference%22:%20%7B%20%22wkid%22:%204326,%20%22latestWkid%22:%204326%20%7D%20%7D&geometryType=esriGeometryPoint&inSR=4326&outSR=4326';
        return this.httpClient.get<any>(url + query, this.httpOptions);
    }

    getPropertyInfo(dblink: string): any {
        return this.httpClient.get<any>(this.propertiesUrl + 'propertyservice/?dblink=' + dblink, this.httpOptions);
    }

    getPropertyBoundingBoxDbLink(dblink: string): any {
        return this.httpClient.get<any>(this.propertiesUrl + 'boundingbox/?dblink=' + dblink, this.httpOptions);
    }

    getProperty(address: string, dblink: string, ltopid: string): any {
        // tslint:disable-next-line: max-line-length
        return this.httpClient.get<any>(this.propertiesUrl + 'propertyservice/?dblink=' + dblink + '&ltopid=' + ltopid + '&address=' + address, this.httpOptions);
    }

    getPropertyByFolio(folio: string): any {
        return this.httpClient.get<any>(this.propertiesUrl + 'propertyservice/?dblink=null&folio=' + folio, this.httpOptions);
    }

    getPropertyByPID(pid: string): any {
        return this.httpClient.get<any>(this.propertiesUrl + 'propertyservice/?dblink=null&ltopid=' + pid, this.httpOptions);
    }

    getAirSpaceDbLink(dbLink: string): any {
        return this.httpClient.get(this.propertiesUrl + 'isAirSpace/?dblink=' + dbLink, this.httpOptions);
    }

    getPropsByGeometry(rings: any): any {
        let spatialRel = 'esriSpatialRelIntersects';
        if (this.toolboxStatus === ToolboxStatus.MailMerge && this.toolboxMailMergeState.selectionBuffer === 0 && this.toolboxMailMergeState.selectionMethod === 'property') {
            spatialRel = 'esriSpatialRelContains';
        }

        // const url = environment.folioSearchApiEndpointUrl;
        const url = this.appSettings['environment.folioSearchApiEndpointUrl'];
        const query = this.appSettings['searchService.cadastral'] + '/query';
        // tslint:disable-next-line: max-line-length
        let parameters = 'where=1%3D1&text=&objectIds=&time=&geometryType=esriGeometryPolygon&inSR=4326&spatialRel=' + spatialRel + '&relationParam=&outFields=*&returnGeometry=true&returnTrueCurves=false&maxAllowableOffset=&geometryPrecision=&outSR=4326&having=&returnIdsOnly=false&returnCountOnly=false&orderByFields=&groupByFieldsForStatistics=&outStatistics=&returnZ=false&returnM=false&gdbVersion=&historicMoment=&returnDistinctValues=false&resultOffset=&resultRecordCount=&queryByDistance=&returnExtentOnly=false&datumTransformation=&parameterValues=&rangeValues=&quantizationParameters=&featureEncoding=esriDefault&f=pjson';
        parameters += '&geometry=' + JSON.stringify(rings);
        return this.httpClient.post<any>(url + query, parameters, {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        });
    }

    getBldgAssetIdByGeometry(rings: any): any {
        const url = this.appSettings['environment.folioSearchApiEndpointUrl'];
        const query = this.appSettings['appConfig.populationQueryEndpoint'] + '/query';
        // tslint:disable-next-line: max-line-length
        let parameters = 'where=1%3D1&text=&objectIds=&time=&geometryType=esriGeometryPolygon&inSR=4326&spatialRel=esriSpatialRelIntersects&relationParam=&outFields=*&returnGeometry=true&returnTrueCurves=false&maxAllowableOffset=&geometryPrecision=&outSR=4326&having=&returnIdsOnly=false&returnCountOnly=false&orderByFields=&groupByFieldsForStatistics=&outStatistics=&returnZ=false&returnM=false&gdbVersion=&historicMoment=&returnDistinctValues=false&resultOffset=&resultRecordCount=&queryByDistance=&returnExtentOnly=false&datumTransformation=&parameterValues=&rangeValues=&quantizationParameters=&featureEncoding=esriDefault&f=pjson';
        parameters += '&geometry=' + JSON.stringify(rings);
        return this.httpClient.post<any>(url + query, parameters, {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        });
    }

    getEnerGovInfo(dbLink: string): any {
        return this.httpClient.get(this.propertiesUrl + 'energov/?dblink=' + dbLink, this.httpOptions);
    }

}
